import React from 'react';
import styled from 'styled-components';

import { ActionColumn } from 'components/pages/photoseries/containers/action-column/action-column.component';
import { DamageLabellingInstruction } from 'components/pages/photoseries/containers/damage-labelling-instructions/damage-labelling-instructions';

const ColumnRightWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

type Icon = React.ReactSVGElement | React.ReactElement;

type ColumnRightPropTypes = {
  currentCount?: number;
  totalCount?: number;
  textNode?: string | React.ReactNode;
  buttonIcon: Icon;
  decorativeIcon?: Icon;
  progressBarIcon: Icon;
  onClickHandler: Function;
  damageLabellingEnabled: boolean;
  damageLabellingInstruction: DamageLabellingInstruction | undefined;
  hideDamageLabellingInstruction: boolean;
  animateActionButton?: boolean;
  toggleComment?: Function;
  toggleUndo?: Function;
  disabled?: boolean;
  isLoading?: boolean;
  buttonRef?: React.Ref<HTMLButtonElement> | undefined;
};

export const ColumnRight: React.FC<ColumnRightPropTypes> = ({
  currentCount,
  totalCount,
  textNode,
  buttonIcon,
  decorativeIcon,
  progressBarIcon,
  onClickHandler,
  damageLabellingEnabled,
  damageLabellingInstruction,
  hideDamageLabellingInstruction,
  animateActionButton,
  toggleComment,
  toggleUndo,
  disabled,
  isLoading,
  buttonRef
}) => (
  <ColumnRightWrapper>
    <ActionColumn
      topRow={{
        progressBar: {
          currentStep: currentCount,
          totalSteps: totalCount,
          textNode,
          icon: progressBarIcon,
          darkMode: true,
        },
        damageLabelling: {
          enabled: damageLabellingEnabled,
          instruction: damageLabellingInstruction,
          hide: hideDamageLabellingInstruction
        }
      }}
      actionButton={{
        icon: buttonIcon,
        disabled,
        onClickHandler,
        animate: animateActionButton,
        isLoading,
        buttonRef
      }}
      bottomRow={{ decorativeIcon, toggleComment, toggleUndo }}
    />
  </ColumnRightWrapper>
);
